export const SET_ALERT = 'SET_ALERT';



// WEBPACK FOOTER //
// ./src/store/reducers/alert/actionTypes.js